import React from 'react'
// import { Scrollbars } from 'react-custom-scrollbars'

// TODO: search for a more updated lib that can replace react-custom-scrollbars
const CustomScrollbars = (props) => (
  <div
    {...props}
    // autoHide
    // renderTrackHorizontal={(props) => <div {...props} style={{ display: 'none' }} className="track-horizontal" />}
  />
)

export default CustomScrollbars
